import "./index.scss";
import React, { useEffect, lazy, Suspense } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { isUserLoggedIn } from "./actions/Auth_action";
import { Change_LangugeHeader } from "./actions/Helper_action";
// Components
import All from "./All";
import "./App.css";
import Redashboard from "./Dashboards/Redashboard";
import PrivateRoute from "./components/HOC/PrivateRoute";
import { LostPassword, Login } from "./containers/Form";
import { Create_Admin, ListAdmin } from "./containers/Admin";
import {
  ListMasrufBranch,
  PrintSalary,
  PunshedFormList,
  ReAccounting,
  RePrintMasrufat,
  SalaryForm,
  PrintSalaryForm,
  PrintPunshed,
  PersentageForm,
  PrintPersentage,
} from "./containers/Acounting";
import {
  ListAgent,
  PrintListAgent,
  PrintListBranch,
  EditAgent,
} from "./containers/Agent";
import {
  PrintListCustomer,
  ReListCustomerDetail,
  ReListZabuns,
} from "./containers/Customers";
import {
  GetAgentByBranch,
  ListBranch,
  EditBranch,
} from "./containers/Branches";
import {
  AllRaportAgentRatio,
  BoxRaport,
  TajRentReport,
  TajSellReport,
  PrintBoxReport,
  AgentPerformance,
  Income,
} from "./containers/AllReports";
import {
  ReEditContractRentList,
  ReEditContractSell,
  ReListRentContract,
  ReListSellContract,
} from "./containers/Contracts";
import {
  ListDeleteParadan,
  ListDeleteRent,
  ListDeleteSell,
  ListDeleteTakeMoney,
  ListDeleteTenants,
} from "./containers/DeleteBills";
import {
  PrintListScurety,
  PrintListTakeMoney,
  PrintListparadan,
  ReListParadan,
  ReListTakeMoney,
  ReListWriteForm,
  RePrintParadan,
  RePrintTakeMoney,
  ReScurityList,
  View_Scurety_component,
  RelistKryar,
} from "./containers/ListBills";
import {
  AllRentContract,
  AllSellContract,
  PrintAllRentContract,
  PrintAllSellContract,
  View_AllRent,
  View_AllSell,
  AllRentContract_Failed,
  AllSellContract_Failed,
} from "./containers/ListContracts";
import {
  AllRentProperty,
  AllSellProperty,
  ReEditRentDetail,
  ReEditSellDetail,
  ReRentListProperty,
  ReSellListProperty,
  AllSellRequired,
} from "./containers/Propertys";
import {
  PrintListTenant,
  ReTenantList,
  ReView_TenantContract,
  ReView_TenantParadan,
  ReView_TenantTakeMoney,
} from "./containers/Tenants";
import {
  BillListingProject,
  CreateProject,
  ListAllprojectBills,
  PrintAllProjects,
  PrintListOfProjectBills,
  RePrintShuqaApartment,
  PrintSupport,
  ReProjectListing,
  ReViewProject,
} from "./containers/Project";
import {
  ListRequests,
  ListRejectRequest,
  ListAcceptRequest,
  HRForms,
  PrintViewHrForm,
} from "./containers/Requests";
import { ListType_Expenses } from "./containers/Expenses";
import { ListBackUp } from "./containers/backup";
const LazyProfile = lazy(() => import("./containers/settings/profile"));
const LazyUserProfile = lazy(() =>
  import("./components/common/header_components/ProfileUser/UserProfile")
);
const LazyListAgentTodo = lazy(() =>
  import("./containers/TodoList/ListAgentTodo")
);
const Profile = () => (
  <Suspense fallback="loading...">
    <LazyProfile />
  </Suspense>
);
const UserProfile = () => (
  <Suspense fallback="loading...">
    <LazyUserProfile />
  </Suspense>
);
const ListAgentTodo = () => (
  <Suspense fallback="loading...">
    <LazyListAgentTodo />
  </Suspense>
);
function App_Admin() {
  const L_status = useSelector((state) => state.AuthReducer.L_status);
  const isAuth = useSelector((state) => state.AuthReducer.isAuth);
  const key_lang = window.localStorage.getItem("key_lang");
  const token = window.localStorage.getItem("token_GPC_admin");
  const dispatch = useDispatch();
  useEffect(() => {
    if (token) {
      dispatch(isUserLoggedIn());
    }
    window.document.body.classList.add("rtl");
    if (key_lang === "krd") {
      window.document.body.classList.add("rtl");
      dispatch(Change_LangugeHeader("Kurdish"));
    } else if (key_lang === "eng") {
      window.document.body.classList.remove("rtl");
      dispatch(Change_LangugeHeader("English"));
    } else if (key_lang === "arb") {
      window.document.body.classList.add("rtl");
      dispatch(Change_LangugeHeader("Arabic"));
    }
  }, [isAuth]);
  return (
    <Router>
      <div className="App">
        {!token && <Redirect from="*" to="/" />}
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/lost-password" component={LostPassword} />
          <Route exact path="/Print_Salary/:from/:to" component={PrintSalary} />
          <Route
            exact
            path="/Print_Masrufat_Branch/:from/:to/:type"
            component={RePrintMasrufat}
          />
          <Route
            exact
            path="/print_Paradan/:id/:index"
            component={RePrintParadan}
          />
          <Route
            exact
            path="/print_TakeMoney/:id/:index"
            component={RePrintTakeMoney}
          />
          <Route exact path="/PrintListAgent" component={PrintListAgent} />
          <Route exact path="/PrintListBranch" component={PrintListBranch} />
          <Route
            exact
            path="/Print_all_takemoney/:type/:status"
            component={PrintListTakeMoney}
          />
          <Route
            exact
            path="/Print_all_payment/:type/:status"
            component={PrintListparadan}
          />
          <Route
            exact
            path="/Print_all_ScurityBill"
            component={PrintListScurety}
          />
          <Route
            exact
            path="/Print_all_contractSell/:type"
            component={PrintAllSellContract}
          />
          <Route
            exact
            path="/Print_all_contractRent/:type"
            component={PrintAllRentContract}
          />
          <Route exact path="/Print_all_tenants" component={PrintListTenant} />
          <Route
            exact
            path="/Print_all_customer"
            component={PrintListCustomer}
          />
          <Route
            exact
            path="/PrintAllBoxReport/:from/:to"
            component={PrintBoxReport}
          />
          <Route
            exact
            path="/print_Apartment_Project/:status"
            component={RePrintShuqaApartment}
          />
          <Route
            exact
            path="/Print_all_Projects"
            component={PrintAllProjects}
          />
          <Route
            exact
            path="/print_Project_list_Bills"
            component={PrintListOfProjectBills}
          />
          <Route exact path="/print_Support" component={PrintSupport} />
          <Route path={`/print_salary_form/:id`} component={PrintSalaryForm} />
          <Route path={`/print_punshed_form/:id`} component={PrintPunshed} />
          <Route path={`/print_ratio_form/:id`} component={PrintPersentage} />
          <Route path={`/print_HrForm`} component={PrintViewHrForm} />
          {L_status !== true ? (
            <>
              <div className="loader-container">
                <div className="spinner"></div>
              </div>
            </>
          ) : (
            <All>
              <PrivateRoute exact path="/dashboard" component={Redashboard} />
              <PrivateRoute
                exact
                path={`/settings/profile`}
                component={Profile}
              />
              <PrivateRoute
                path={`/List_Projects`}
                component={ReProjectListing}
              />
              <PrivateRoute
                path={`/Create_Project`}
                component={CreateProject}
              />
              <PrivateRoute
                path={`/View_Project_Path/:id_path`}
                component={ReViewProject}
              />
              <PrivateRoute
                path={`/List_All_Project_Bills`}
                component={BillListingProject}
              />
              <PrivateRoute
                path={`/All_Project_Bills/:id`}
                component={ListAllprojectBills}
              />
              <PrivateRoute
                exact
                path={`/UserProfile`}
                component={UserProfile}
              />
              <PrivateRoute
                exact
                path={`/Branch/list_Branch`}
                component={ListBranch}
              />
              <PrivateRoute
                exact
                path={`/view_Profile_Branch/:id`}
                component={EditBranch}
              />
              <PrivateRoute
                exact
                path={`/Agent/Agent_List`}
                component={ListAgent}
              />
              <PrivateRoute
                exact
                path={`/view_Profile_Agent/:id`}
                component={EditAgent}
              />
              <PrivateRoute
                exact
                path={`/Branch/List_users/:id`}
                component={GetAgentByBranch}
              />
              <PrivateRoute
                exact
                path={`/Sell_list_property/:id`}
                component={ReSellListProperty}
              />
              <PrivateRoute
                exact
                path={`/Rent_list_property/:id`}
                component={ReRentListProperty}
              />
              <PrivateRoute
                exact
                path={`/view_sell_detail/:id`}
                component={ReEditSellDetail}
              />
              <PrivateRoute
                exact
                path={`/view_rent_detail/:id`}
                component={ReEditRentDetail}
              />
              <PrivateRoute
                exact
                path={`/Sell_list_contract/:id`}
                component={ReListSellContract}
              />
              <PrivateRoute
                exact
                path={`/Rent_list_contract/:id`}
                component={ReListRentContract}
              />
              <PrivateRoute
                exact
                path={`/view_rent_contract/:id`}
                component={ReEditContractRentList}
              />
              <PrivateRoute
                exact
                path={`/view_sell_contract/:id`}
                component={ReEditContractSell}
              />
              <PrivateRoute
                path={`/todo_agent_list`}
                component={ListAgentTodo}
              />
              <PrivateRoute path={`/list_salary`} component={ReAccounting} />
              <PrivateRoute
                path={`/list_BranchMasrufat`}
                component={ListMasrufBranch}
              />
              <PrivateRoute
                path={`/list_takemoney`}
                component={ReListTakeMoney}
              />
              <PrivateRoute path={`/list_paradn`} component={ReListParadan} />
              <PrivateRoute path={`/list_scurety`} component={ReScurityList} />
              <PrivateRoute
                path={`/list_customers_anket`}
                component={RelistKryar}
              />
              <PrivateRoute
                path={`/view_scurety/:id`}
                component={View_Scurety_component}
              />
              <PrivateRoute
                path={`/list_all_sell_contracts`}
                component={AllSellContract}
              />
              <PrivateRoute
                path={`/list_all_sell_contracts_fast`}
                component={AllSellContract_Failed}
              />
              <PrivateRoute
                path={`/list_all_rent_contracts`}
                component={AllRentContract}
              />
              <PrivateRoute
                path={`/list_all_rent_contracts_fast`}
                component={AllRentContract_Failed}
              />
              <PrivateRoute
                path={`/view_all_sell/:id/:index`}
                component={View_AllSell}
              />
              <PrivateRoute
                path={`/view_all_rent/:id/:index`}
                component={View_AllRent}
              />
              <PrivateRoute path={`/Create_Admin`} component={Create_Admin} />
              <PrivateRoute path={`/List_Admin`} component={ListAdmin} />
              <PrivateRoute
                path={`/All_Project_Report`}
                component={AllRaportAgentRatio}
              />
              <PrivateRoute
                path={`/Sell_Taj_Report`}
                component={TajSellReport}
              />
              <PrivateRoute
                path={`/Rent_Taj_Report`}
                component={TajRentReport}
              />
              <PrivateRoute
                exact
                path={`/All_Sell_Property`}
                component={AllSellProperty}
              />
              <PrivateRoute
                exact
                path={`/All_Rent_Property`}
                component={AllRentProperty}
              />
              <PrivateRoute
                path={`/All_Required_Sell`}
                component={AllSellRequired}
              />
              <PrivateRoute path={`/List_Tenants`} component={ReTenantList} />
              <PrivateRoute
                path={`/Tenant_View_All_TakeMoney/:id`}
                component={ReView_TenantTakeMoney}
              />
              <PrivateRoute
                path={`/Tenant_View_All_Paradan/:id`}
                component={ReView_TenantParadan}
              />
              <PrivateRoute
                path={`/Tenant_View_All_Contract/:id`}
                component={ReView_TenantContract}
              />
              <PrivateRoute
                path={`/List_Writers`}
                component={ReListWriteForm}
              />
              {/* punshed & bounes form & Salary */}
              <PrivateRoute path={`/List_bounes`} component={PunshedFormList} />
              <PrivateRoute path={`/List_Form_Salary`} component={SalaryForm} />
              <PrivateRoute
                path={`/List_Form_persentage`}
                component={PersentageForm}
              />
              {/* customer detail */}
              <PrivateRoute
                path={`/List_Customer_Detail`}
                component={ReListCustomerDetail}
              />
              <PrivateRoute
                path={`/List_sellers_buyers`}
                component={ReListZabuns}
              />
              {/* delete bills recover */}
              <PrivateRoute
                path={`/List_delete_Sell`}
                component={ListDeleteSell}
              />
              <PrivateRoute
                path={`/List_delete_Rent`}
                component={ListDeleteRent}
              />

              <PrivateRoute
                path={`/List_delete_takemoney`}
                component={ListDeleteTakeMoney}
              />
              <PrivateRoute
                path={`/List_delete_payments`}
                component={ListDeleteParadan}
              />
              <PrivateRoute
                path={`/List_delete_tenants`}
                component={ListDeleteTenants}
              />
              <PrivateRoute
                path={`/List_type_exp`}
                component={ListType_Expenses}
              />
              <PrivateRoute
                path={`/agent_performance`}
                component={AgentPerformance}
              />
              {/* Box Report */}
              <PrivateRoute path={`/All_Box_Report`} component={BoxRaport} />
              <PrivateRoute path={`/income_report`} component={Income} />
              {/* backup */}
              <PrivateRoute path={`/back_up`} component={ListBackUp} />
              {/* Hr */}
              <PrivateRoute path={`/List_requests`} component={ListRequests} />
              <PrivateRoute
                path={`/List_reject_requests`}
                component={ListRejectRequest}
              />
              <PrivateRoute
                path={`/List_accept_requests`}
                component={ListAcceptRequest}
              />
              <PrivateRoute path={`/hr_forms`} component={HRForms} />
            </All>
          )}
        </Switch>
      </div>
    </Router>
  );
}
export default App_Admin;
